import {Injectable, Injector} from '@angular/core';
import {Overlay, OverlayRef} from "@angular/cdk/overlay";
import {ComponentPortal, ComponentType} from "@angular/cdk/portal";
import {ModalConfig} from "../models/modal-config";

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private overlay: Overlay, private injector: Injector) { }

  open<T>(component: ComponentType<T>, config?: ModalConfig) {
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      disposeOnNavigation: true,
    });
    overlayRef.outsidePointerEvents().subscribe(() => overlayRef.dispose());

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: OverlayRef, useValue: overlayRef },
        { provide: ModalConfig, useValue: config },
      ]
    });

    const portal = new ComponentPortal(component, null, injector);
    overlayRef.attach(portal);
  }
}
